import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useProfiles } from "../profiles/ProfileContext";
import { Button } from "../components/ui/Button";
import { PageHeader } from "../components/Surface";
import { ListRow } from "../components/ListTable";
import { Results, ItemCard } from "../components/Paged";
import { myJobs, payLabel, HIRING_TYPES, type MyJob } from "../lib/jobs";

export function MyJobs() {
  const { active } = useProfiles();
  const isHiring = active ? HIRING_TYPES.includes(active.type) : false;
  const [jobs, setJobs] = useState<MyJob[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!active || !isHiring) {
      setLoading(false);
      return;
    }
    myJobs(active.id).then((r) => setJobs(r.jobs)).finally(() => setLoading(false));
  }, [active, isHiring]);

  return (
    <div className="grid gap-6">
      <PageHeader
        title="My postings"
        subtitle="Your job postings and applicant activity."
        actions={<Link to="/jobs/new"><Button>Post a job</Button></Link>}
      />
      {!isHiring ? (
        <p className="text-sm text-muted">Switch to a hiring profile to see your postings.</p>
      ) : loading ? (
        <p className="font-mono text-sm text-muted">Loading…</p>
      ) : (
        <Results
          items={jobs}
          perPage={12}
          defaultView="list"
          listColumns={["Posting", "Status", "Applicants"]}
          gridClass="grid gap-3 sm:grid-cols-2 lg:grid-cols-3"
          empty={<p className="font-mono text-sm text-muted">You haven't posted any jobs yet.</p>}
          renderRow={(j) => (
            <ListRow key={j.id} to={`/jobs/${j.id}`} title={j.title} meta={[payLabel(j.pay_min, j.pay_max, j.pay_type), j.location].filter(Boolean).join(" · ")} status={j.status} right={`${j.application_count} applicant${j.application_count === 1 ? "" : "s"}`} />
          )}
          renderCard={(j) => (
            <ItemCard key={j.id} to={`/jobs/${j.id}`} title={j.title} meta={[payLabel(j.pay_min, j.pay_max, j.pay_type), j.location].filter(Boolean).join(" · ")} status={j.status} right={`${j.application_count} applicant${j.application_count === 1 ? "" : "s"}`} />
          )}
        />
      )}
    </div>
  );
}
